export enum ReportType {
    TRANSPORT,
    TIME,
    SICK,
    DIET
}

export enum TransportType {
    CompanyCar = 1, PrivateCar = 2, Passenger = 3, Plain = 4, Helicopter = 5, Train = 9, Bus = 10, Taxi = 11, Boat = 12, Motorcycle = 13, Truck = 15, Van = 16, OtherCar = 17, OtherTransport = 18, PublicTransport = 4
}

export class Time {
    hours: number
    minutes: number

    constructor (hours: number, minutes: number) {
      this.hours = hours
      this.minutes = minutes
    }

    static fromString (timeString: string): Time {
      const [hours, minutes] = timeString.split(':').map(Number)
      return new Time(hours, minutes)
    }

    toString (): string {
      return `${this.hours.toString().padStart(2, '0')}:${this.minutes.toString().padStart(2, '0')}`
    }

    static difference (startTime: Time, endTime: Time): Time {
      const startMinutes = startTime.hours * 60 + startTime.minutes
      const endMinutes = endTime.hours * 60 + endTime.minutes
      const diffMinutes = endMinutes - startMinutes

      const hours = Math.floor(diffMinutes / 60)
      const minutes = diffMinutes % 60

      return new Time(hours, minutes)
    }
}

// Base class for Report
export class Report {
  id: string | undefined
  employeeNumber: number | undefined
  date: Date | string | undefined
  timeFrom: Time | undefined
  timeTo: Time | undefined
  timeSpent: string | undefined
  timeSpentWithGap: string | undefined
  remark: string | undefined
  project: string | undefined
  state: string | undefined
}

export class TransportReport extends Report {
  transportType: TransportType | undefined
  kmUsed: number | undefined
  addressFrom: string | undefined
  addressTo: string | undefined
}

export class TimeReport extends Report {

}

export class SicknessReport extends Report {

}

export class DietReport {
  id: string | undefined
  employeeNumber: number | undefined
  weekNumber: number | undefined
  year: number = new Date().getFullYear()
  daysAmountBoarding: number | undefined
  daysAmountLodging: number | undefined
  amountConnectingHours: number | undefined
  state: string | undefined
}

export class ReportWeekSummary {
  dayNumber: number | undefined
  project: string | undefined
  hours: number | undefined
}
